import React from "react";

export interface DatePickerProps {
  value?: string;
  format?: string;
  onChange?(): void;
}

export default ({ value, format, onChange }: DatePickerProps) => {
  return <div>DatePicker</div>;
};
